
import React from 'react';
import {HighlightRects} from "../../funcs/utils";
import { OptionMenu } from "../../../lib/prm/option-menu";
import { Name } from "../../../lib/prm/name";
import { FlowRender } from "../../../lib/flow-render";
import { deep_copy } from "../../../lib/js-utils";
import { Spinner } from "../../funcs/utils";
import { Text } from "../../../lib/prm/text";
import { Modal2 } from "../modal";
import { InitiateMicroPayments} from "../../payment/actions";
import {config_to_url} from "../../helper/url";
import {MX_STATE} from "../../payment/mx-connect";
import {objToUrlParam} from "../../../lib/url-util";
import {IAVFlow} from "../../payment/iav-flow";

const FUNDING_SOURCE_TYPE = new OptionMenu(
  new Name("FUNDING_SOURCE_TYPE"),
  [
    new Name("iav", "Instantly add an account"),
    new Name("ach", "Add an ACH source by using micropayments"),
  ]);

const payment_routing_number = new Text(
  new Name("payment_routing_number"));

const payment_account_number = new Text(
  new Name("payment_account_number"));

const payment_account_name = new Text(
  new Name("payment_account_name"));

const payment_account_type = new OptionMenu(
  new Name("payment_account_type"),
  [
    new Name("checking", "Checking"),
    new Name("savings", "Savings"),
  ]
);

const ALL_PRMS = new FlowRender(0, [
  FUNDING_SOURCE_TYPE,
  payment_routing_number,
  payment_account_number,
  payment_account_name,
  payment_account_type,
]);

const on_iav_close = (component) => {
  const args = deep_copy(component.props.args);
  delete args.flow;
  component.setState({
    error: "",
    iav_token: "",
    mx_flow: MX_STATE.INIT,
  })
  component.props.navigatePath(component.props.path, args);
}

const on_iav_state = component => mx_state => {
  component.setState({
    mx_flow: mx_state,
  })
}

const add_funding_source = component => {
  const ping_url = config_to_url(component.props.config);
  const url = ping_url + component.props.path + objToUrlParam(component.props.args);

  return (
    <div>
      <div style={{display: "inline-block", marginLeft: "2rem"}}>
        <IAVFlow
          url={url}
          on_iav_state={on_iav_state(component)}
          component={component}
          state={component.state}
          button_text={"Click to instantly add an account"}/>
      </div>
    </div>
  )
};

const on_micro_dialog_close = (component) => () => {
  const args = deep_copy(component.props.args);
  delete args.flow;
  component.setState({ highlight_rects: [], ach_error: "" });
  component.props.navigatePath(component.props.path, args);
}

const on_send_microdeposits = component => () => {

  const params = [ payment_account_name, payment_routing_number, payment_account_number ];
  const highlight_rects = [];

  params.forEach(param => {
    param.isFilledElseHighlight(component.state, highlight_rects);
  });

  if (highlight_rects.length > 0) {
    component.setState({ highlight_rects });
    return;
  }

  component.setState( { loading_ach: true, ach_error: "" });
  InitiateMicroPayments(
    component.props.token, null,
    payment_routing_number.getValue(component.state),
    payment_account_number.getValue(component.state),
    payment_account_type.getValue(component.state).id,
    payment_account_name.getValue(component.state))
    .then(result => {
      component.setState( { loading_ach: false });
      if (!result.success) {
        component.setState({ ach_error: result.message});
      } else {
        // Funding sources are always stored in dwolla_0000
        component.props.dwollaUpdate(result.dwolla, 0);
        on_micro_dialog_close(component)();
      }
    })

}

const render_ach_flow = component => {

  const loading = component.state.loading_ach;

  const buttonList = [
    {
      label: "Cancel",
      cb: on_micro_dialog_close(component),
    },
    {
      label: (
        <div style={{position: "relative"}}>
          <span style={{visibility: loading ? "hidden" : "visible"}}>Send Microdeposits</span>
          <div
            align={"center"}
            style={{visibility: loading ? "visible" : "hidden", width: "100%", position: "absolute", top: "0", left: "0"}}>
            <Spinner/>
          </div>
        </div>
      ),
      cb: on_send_microdeposits(component),
    }
  ];

  const text = "We will verify your account by sending two very small deposits. They "
    + "should arrive in a few days";
  const error = component.state.ach_error
    ? (<span style={{ color: "red"}}>{component.state.ach_error}</span>)
    : null;

  const header = (<div style={{width: "100%"}} align={"center"}>Add Payment Source</div>);
  const on_highlight_click = () => {
    component.setState({ highlight_rects: []});
  }

  return (
    <Modal2
      container_style={{width: "40rem"}}
      show={true}
      onDismiss={on_micro_dialog_close(component)}
      header={header}
      buttonList={buttonList}
      onClose={on_micro_dialog_close(component)}>
      <div ref={component.dialog_ref} style={{position: "relative"}}>
        <HighlightRects
          rects={component.state.highlight_rects}
          container_ref={component.dialog_ref}
          onClick={on_highlight_click}/>
        <div>
          { payment_account_name.renderInputDiv(component, { width: "100%" }, "Account Name") }
          <div style={{height: "0.5rem"}}/>
          { payment_account_type.renderMenuDiv(component, { width: "100%" }, "Account Type") }
          <div style={{height: "0.5rem"}}/>
          { payment_routing_number.renderInputDiv(component, {width: "100%" }, "ABA/Routing Number")}
          <div style={{height: "0.5rem"}}/>
          { payment_account_number.renderInputDiv(component, {width: "100%" }, "Account Number")}
          <div style={{height: "1rem"}}/>
          <div>{error || text}</div>
        </div>
      </div>
    </Modal2>
  )
}

const add_funding_source_state = component => {
  const state = {
    error: "",
    mx_flow: MX_STATE.INIT,
    highlight_rects: [],
    loading_ach: false,
    ach_error: "",
  }
  ALL_PRMS.init(state, {}, component);
  FUNDING_SOURCE_TYPE.setValue(state, "iav");
  component.dialog_ref = React.createRef();
  return state;
}

const funding_source_did_update = (component, prev_props) => {
  const get_flow = props => {
    return props.args && props.args.flow;
  };
  if (get_flow(prev_props) && !get_flow(component.props)) {
    component.setState({ error: "" });
  }
};

export { add_funding_source_state, funding_source_did_update,
  add_funding_source, render_ach_flow, on_iav_close }
